import { demoProfile } from 'src/features/monitoringDashboardAlpha/demo/profile'
import { localeAwareSort } from 'src/util/sortStringsLocaleAware'

/**
 * useQueryUserPlaceNodes / useQueryPlaceNodes の選択結果と同じ形。
 * デモ時は現場の絞り込み候補と L2 見出しの現場名を、API でなくこちらから引く。
 */
export type DemoPlaceNode = {
  uuid: string
  name: string
  type: 'place' | 'placeGroup'
}

/**
 * プロファイルの現場グループ・現場を名前順に並べたもの。
 * モジュール定数にしているのは、コンポーネントの useMemo / useEffect の依存に渡しても参照が変わらないようにするため。
 */
export const demoPlaceNodes: DemoPlaceNode[] = [
  ...demoProfile.placeGroups.map(
    (group): DemoPlaceNode => ({
      uuid: group.uuid,
      name: group.name,
      type: 'placeGroup',
    }),
  ),
  ...demoProfile.places.map(
    (place): DemoPlaceNode => ({
      uuid: place.uuid,
      name: place.name,
      type: 'place',
    }),
  ),
].sort((a, b) => localeAwareSort(a.name, b.name))
